import * as React from "react";

function PhotoFilmIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M464 448c0 8.822-7.178 16-16 16h-48v-80h-47.99l-.01 80H160V128H64c-35.35 0-64 28.7-64 64v256c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64l.008-64H464v64zm-352 16H64c-8.822 0-16-7.178-16-16v-48h64v64zm0-112H48v-64h64v64zm0-112H48v-48c0-8.822 7.178-16 16-16h48v64zM576 0H256c-35.3 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V64c0-35.35-28.7-64-64-64zm16 288c0 8.822-7.178 16-16 16L466.7 143.1c-3-4.4-8-7.1-13.4-7.1a15.978 15.978 0 0 0-13.31 7.125l-62.74 94.11-22.35-30.66c-3-4.175-7.8-6.575-13.8-6.575a16.007 16.007 0 0 0-12.93 6.574L256 304c-8.8 0-16-7.2-16-16V64c0-8.822 7.178-16 16-16h320c8.822 0 16 7.178 16 16v224zM303.1 80c-17.67 0-32 14.33-32 32s14.33 32 32 32c17.68 0 32-14.33 32-32s-13.4-32-32-32z"
  }));
}

const ForwardRef = React.forwardRef(PhotoFilmIcon);
export default ForwardRef;